import Vue from "vue"
import Router from "vue-router"

// 路由懒加载
const layout = () => import("@/layout/index")
// ===================首页==============================
const home = () => import("@/pages/home/index")
// ===================会员协议==========================
const UserAgreement = () => import("../pages/userAgreement/index.vue")
// ===================会员个人信息相关=============
const vipInfo = () => import("@/pages/vipInfo/vipInfo")
const vipGoodsDetail = () => import("@/pages/vipInfo/vipGoodsDetail")
const detail = () => import("@/pages/vipInfo/detail")
const setTings = () => import("@/pages/vipInfo/settings")
const settingPassword = () => import("@/pages/vipInfo/settingPassword.vue")
const vipCenter = () => import("@/pages/vipCenter")
// ===========我的咨询=========================
const myInquiry = () => import("@/pages/myInquiry/index")
// 404页
const NotFoundComponent = () => import("@/pages/404")
// ===========普通咨询=================
const query = () => import("@/pages/query/index.vue")
const queryType = () => import("@/pages/query/queryType.vue")
const logicTree = () => import("@/pages/query/logicTree.vue")
const queryDetail = () => import("@/pages/query/queryDetail/index.vue")
const queryContent = () => import("@/pages/query/queryContent.vue")
const supplementAndQuestioning = () => import("@/pages/query/supplementAndQuestioning.vue")
// ================完善宠物信息=======================
const perfectPetInfo = () =>
    import("@/pages/PerfectPetInfo/perfectPetInfo.vue")

// ========================登录===========================
const normalLogin = () => import("@/pages/login/normalLogin")
// =======================优惠券==================================
const coupon = () => import("@/pages/coupon/index.vue")
// =============================关注服务号==========================
const server = () => import("@/pages/serviceTips/index.vue")
// ==========================分享好礼========================
const SharePage = () => import("@/pages/SharePage/index.vue")
// =====================会员club===============================
const vipClub = () => import("@/pages/vipClub/index.vue")
// ================招聘===========================
const recruit = () => import("@/pages/recruit/index.vue")
const recruitDetail = () => import("@/pages/recruit/recruitDetail.vue")
// 待完成
const UnderConstruction = () => import("../pages/underConstruction.vue")

Vue.use(Router)

export default new Router({
    mode: "history",
    base: "/web",
    routes: [
        {
            path: `/normalLogin`,
            name: 'normalLogin',
            component: normalLogin,
            meta: {
                title: "登录",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: '/catEncyclopedia/:type',
            name: 'catEncyclopedia',
            component: () => import('../pages/CatEncyclopedia/index.vue'),
            meta: {
                title: "猫咪百科",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/stapleFoodCan`,
            name: 'stapleFoodCan',
            component: () => import('../pages/stapleFoodCan/index.vue'),
            meta: {
                title: "王小磊",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/code`,
            name: 'code',
            component: () => import('../pages/liveCode/index.vue'),
            meta: {
                title: "王小磊二维码",
                requireLogin: false // 登录状态验证
            },
        },
      {
        path: `/taggedCode`,
        name: 'taggedCode',
        component: () => import('../pages/taggedQR/index.vue'),
        meta: {
          title: "王小磊二维码",
          requireLogin: false // 登录状态验证
        },
      },
      {
        path: `/qr`,
        name: 'qr',
        component: () => import('../pages/qr/index.vue'),
        meta: {
          title: "二维码",
          requireLogin: false // 登录状态验证
        },
      },
      {
        path: `/taggedCodedwjd`,//动物鉴定拉新二维码
        name: 'taggedCodedwjd',
        component: () => import('../pages/taggedQRdwjd/index.vue'),
        meta: {
          title: "动物鉴定专家",
          requireLogin: false // 登录状态验证
        },
      },
      {
        path: `/taggedCodems`,//马术拉新二维码
        name: 'taggedCodems',
        component: () => import('../pages/taggedQRms/index.vue'),
        meta: {
          title: "达根斯",
          requireLogin: false // 登录状态验证
        },
      },
      {
        path: `/taggedCodesah`,//圣爱和拉新二维码
        name: 'taggedCodesah',
        component: () => import('../pages/taggedQRsah/index.vue'),
        meta: {
          title: "圣爱和",
          requireLogin: false // 登录状态验证
        },
      },
      {
        path: `/code2312`,
        name: 'code2312',
        component: () => import('../pages/liveCode2312/index.vue'),
        meta: {
          title: "王小磊合作方二维码",
          requireLogin: false // 登录状态验证
        },
      },
        {
            path: `/goods`,
            name: 'wxLogin',
            component: () => import('../pages/login/wxLogin.vue'),
            meta: {
                title: "登录",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/qwgoods`,
            name: 'Login',
            component: () => import('../pages/login/qwLogin.vue'),
            meta: {
                title: "登录",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/`,
            // name: 'layout',
            component: layout,
            children: [{
                path: `/`,
                name: 'home',
                component: home,
                meta: {
                    title: "萌爪宠物医生",
                    requireLogin: false // 登录状态验证
                },
            },
            // 新个人中心
            // {
            //     path: `/vipCenter`,
            //     name: 'vipCenter',
            //     component: vipCenter
            // },
            {
                path: `/vipCenter`,
                name: 'vip',
                component: () => import('@/pages/vipCenter/vip.vue'),
                meta: {
                    title: "萌爪宠物医生",
                    requireLogin: true // 登录状态验证
                },
            },
            // 新的我的询问
            {
                path: `/myinquiry`,
                name: 'myinquiry',
                component: myInquiry,
                meta: {
                    title: "萌爪宠物医生",
                    keepAlive: true,
                    requireLogin: true
                }
            },
            // 会员club
            {
                path: '/vipClub',
                name: 'vipClub',
                component: vipClub,
                meta: {
                    title: "会员商城",
                    requireLogin: true // 登录状态验证
                },
            },
            // 个人中心
            {
                path: `/vipInfo`,
                component: vipInfo,
                children: [{
                    path: 'detail',
                    component: detail,
                    meta: {
                        title: "个人信息",
                        requireLogin: true // 登录状态验证
                    },
                },
                {
                    path: '/setTings',
                    component: setTings,
                    meta: {
                        title: "设置",
                        requireLogin: true // 登录状态验证
                    },
                },
                {
                    path: "/settingPassword",
                    component: settingPassword,
                    meta: {
                        title: "设置密码",
                        requireLogin: true // 登录状态验证
                    },
                }
                ]
            }
            ]
        },
        {
            path: '/pay',
            name: 'pay',
          meta: {
              title: "支付"
          },
            component: () => import('@/pages/pay/index.vue')
        },
        {
            path: `/personalCenter`,
            name: 'vip',
            component: () => import('@/pages/vipCenter/vip.vue'),
            meta: {
                title: "萌爪宠物医生",
                requireLogin: true // 登录状态验证
            },
        },
        {
            path: `/mobilUserAgreement`,
            name: 'mobilUserAgreement',
            component: () => import('../pages/userAgreement/mobilAgreement.vue'),
            meta: {
                title: "用户协议",
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/mobile`,
            name: 'mobile',
            component: () => import('../pages/mobile/index.vue'),
            meta: {
                title: "萌爪宠物医生",
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/mobilUserAgree`,
            name: 'mobilUserAgree',
            component: () => import('../pages/userAgreement/userAgree.vue'),
            meta: {
                title: "用户协议",
                requireLogin: false // 登录状态验证
            }
        },
        // 预约咨询数量
        {
            path: `/appointmentCount`,
            name: 'appointmentCount',
            component: () => import('../pages/vipCenter/appointmentCount.vue'),
            meta: {
                title: "咨询次数",
                requireLogin: true // 登录状态验证
            },
        },
        {
            path: '/expertquestion',
            name: 'expertquestion',
            redirect: '/expertquestion/',
            component: () => import('@/pages/expertQuestion/index.vue'),
            meta: {
                title: "专家问答",
                requireLogin: false // 登录状态验证
            },
            children: [
                {
                    path: '/',
                    name: 'questionlist',
                    component: () => import('@/pages/expertQuestion/questionList.vue'),
                    meta: {
                        title: "问答列表",
                        requireLogin: false // 登录状态验证
                    },
                },
                {
                    path: 'questiondetail',
                    name: 'questiondetail',
                    component: () => import('@/pages/expertQuestion/detail.vue'),
                    meta: {
                        title: "问答详情",
                        requireLogin: false // 登录状态验证
                    },
                },
                {
                    path: 'search',
                    name: 'questionsearch',
                    component: () => import('@/pages/expertQuestion/search.vue'),
                    meta: {
                        title: "搜索问答",
                        requireLogin: false // 登录状态验证
                    },
                }

            ]
        },
        // 简易咨询
        {
            path: `/easyQuery`,
            name: 'easyQuery',
            component: () => import('../pages/easyQuery/index.vue'),
            meta: {
                title: "简易咨询",
                requireLogin: false // 登录状态验证
            }
        },
        //SEM微宠医 狗
        {
            path: `/semWcyDog`,
            name: 'semWcyDog',
            component: () => import('../pages/seoTestPage/semWcyDog.vue'),
            meta: {
                title: '狗狗疾病问诊',
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/semWcyYy`,
            name: 'semWcyYy',
            component: () => import('../pages/seoTestPage/semWcyYy.vue'),
            meta: {
                title: '宠物问诊',
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/semWcyDownload`,
            name: 'semWcyDownload',
            component: () => import('../pages/seoTestPage/download.vue'),
            meta: {
                title: '宠物问诊',
                requireLogin: false // 登录状态验证
            }
        },
        //简易提问
        {
            path: `/semQuery`,
            name: 'semQuery',
            component: () => import('../pages/easyQuery/query.vue'),
            meta: {
                title: "快速提问",
                requireLogin: false // 登录状态验证
            }
        },
        //AI简易提问
        {
            path: `/semAIQuery`,
            name: 'semAIQuery',
            component: () => import('../pages/easyQuery/AIQuery.vue'),
            meta: {
                title: "快速提问",
                requireLogin: false // 登录状态验证
            }
        },
        // sem简易登录
        {
            path: `/semLogin`,
            name: 'semLogin',
            component: () => import('../pages/easyQuery/login.vue'),
            meta: {
                title: "登录",
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/vomit`,
            name: 'all',
            component: () => import('../pages/seoTestPage/allSemPage.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            }
        },
        {
            path: `/seoDetail`,
            name: 'seoDetail',
            component: () => import('../pages/seoTestPage/simple.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/mzWxl`,
            name: 'mzWxl',
            component: () => import('../pages/seoTestPage/wxl.vue'),
            meta: {
                title: '专业兽医',
                requireLogin: false // 登录状态验证
            },
        },
        //SEM猫咪落地页
        {
            path: `/semWcyCat`,
            name: 'semWcyCat',
            component: () => import('../pages/seoTestPage/semWcyCat.vue'),
            meta: {
                title: '猫咪疾病问诊',
                requireLogin: false // 登录状态验证
            },
        },
        //呕吐文章页
        {
            path: `/article`,
            name: 'article',
            component: () => import('../pages/seoTestPage/article.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        //新版
        {
            path: `/semPage`,
            name: 'semPage',
            component: () => import('../pages/seoTestPage/newSem.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        //seo绝育询问单
        {
            path: `/seoNewDetail`,
            name: 'seoNewDetail',
            component: () => import('../pages/seoTestPage/newSimple.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/seoSolo`,
            name: 'seoSolo',
            component: () => import('../pages/seoTestPage/solo.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/seoList`,
            name: 'seoList',
            component: () => import('../pages/seoTestPage/detailList.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            // 二维码扫描页
            path: '/personalLink',
            name: 'personalLink',
            component: () => import('../pages/other/qrCode.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },


        {
            // 下线小程序提示页
            path: '/offlineNotification',
            name: 'offlineNotification',
            component: () => import('../pages/activity/offlineNotification/index.vue'),
            meta: {
                title: "下线通知",
                requireLogin: true // 登录状态验证
            },
        },

        {
            // 服务号推广活动
            path: '/serverNumberActivity',
            name: 'serverNumber',
            component: () => import('../pages/activity/serverNumber/index.vue'),
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: `/userAgreement`,
            name: 'UserAgreement',
            component: UserAgreement,
            meta: {
                title: "用户协议",
                requireLogin: false // 登录状态验证
            },
        },
        // 会员产品详情
        {
            path: '/vipGoodsDetail',
            name: 'vipGoodsDetail',
            component: vipGoodsDetail,
            meta: {
                title: "会员介绍",
                requireLogin: true // 登录状态验证
            },
        },
        // 优惠券
        {
            path: '/coupon',
            name: 'coupon',
            component: coupon,
            meta: {
                title: "优惠券",
                requireLogin: true // 登录状态验证
            },
        },
        // 完善宠物资料
        {
            path: '/perfectPetInfo',
            name: 'perfectPetInfo',
            component: perfectPetInfo,
            meta: {
                title: "完善资料",
                requireLogin: true // 登录状态验证
            },
        },
        {
            // 普通咨询
            path: `/query`,
            name: 'query',
            component: query,
            children: [{
                path: `queryType`,
                name: 'queryType',
                component: queryType,
                meta: {
                    title: "咨询类型",
                    requireLogin: true // 登录状态验证
                },
            },
            {
                path: `logicTree`,
                name: 'logicTree',
                component: logicTree,
                meta: {
                    title: "留言咨询",
                    requireLogin: true // 登录状态验证
                },
            },
            {
                path: `queryDetail`,
                name: 'queryDetail',
                component: queryDetail,
                meta: {
                    title: "咨询详情",
                    requireLogin: false // 登录状态验证
                },
            },
            {
                path: `queryContent`,
                name: 'queryContent',
                component: queryContent,
                meta: {
                    title: "留言咨询",
                    requireLogin: true // 登录状态验证
                },
            }, {
                path: `supplementAndQuestioning`,
                name: 'supplementAndQuestioning',
                component: supplementAndQuestioning,
                meta: {
                    title: "留言咨询",
                    requireLogin: true // 登录状态验证
                },
            }
            ]
        },
        {
            path: '/server',
            component: server,
            meta: {
                title: "服务号",
                requireLogin: true // 登录状态验证
            },
        },
        // 新的我的询问无tab栏
        {
            path: `/appointmentHistory`,
            name: 'appointmentHistory',
            component: myInquiry,
            meta: {
                keepAlive: true,
                requireLogin: false,
                title: `咨询历史`
            }
        },
        // 服务号
        // 404
        {
            path: '/404',
            component: NotFoundComponent,
            meta: {
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: '/underConstruction',
            component: UnderConstruction,
            meta: {
                title: "开发中",
                requireLogin: false // 登录状态验证
            },
        },

        {
            path: '/SharePage',
            component: SharePage,
            meta: {
                title: "分享",
                requireLogin: false // 登录状态验证
            },
        },
        // 招聘
        {
            path: '/recruit',
            component: recruit,
            meta: {
                title: "加入我们",
                requireLogin: false // 登录状态验证
            },
        },
        {
            path: '/recruitDetail',
            component: recruitDetail,
            meta: {
                title: "加入我们",
                requireLogin: false // 登录状态验证
            },
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js